import React, { useState } from 'react';
import CommonModal from 'src/components/CommonModal';
import InputTextArea from 'src/components/InputTextArea';
import { updateOrderLegNotes } from 'src/services/OrderService';

interface IProps {
    orderLegId: number;
    noteType: 'pickup' | 'delivery';
    existingNotes: string | null;
    onClose: () => void;
    onSaved: (notes: string) => void;
}

const PickupNotesModal = ({ orderLegId, noteType, existingNotes, onClose, onSaved }: IProps) => {
    const [notes, setNotes] = useState(existingNotes ?? '');
    const [isSaving, setIsSaving] = useState(false);

    const title = noteType === 'pickup' ? 'Pickup Notes' : 'Delivery Notes';
    const label = noteType === 'pickup' ? 'Enter Pickup Notes' : 'Enter Delivery Notes';

    const handleSave = async () => {
        setIsSaving(true);

        try {
            await updateOrderLegNotes(orderLegId, noteType, notes);
            onSaved(notes);
        } catch (error) {
            console.error('Error saving notes:', error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <CommonModal
            title={title}
            handleClose={onClose}
            size="max-w-[500px]"
            primaryBtnText="Save"
            primaryBtnOnClick={handleSave}
            primaryBtnLoading={isSaving}
            secondaryBtnText="Cancel"
            secondaryBtnOnClick={onClose}
        >
            <div className="p-4">
                <InputTextArea label={label} placeholder="Enter a description..." value={notes} onChangeFunc={(e) => setNotes(e.target.value)} maxLength={5000} rows={5} />
            </div>
        </CommonModal>
    );
};

export default PickupNotesModal;
